import { configureStore } from '@reduxjs/toolkit'
import costModelReducer from './redux/costModelSlice'

export default configureStore({
  reducer: {
    costModel: costModelReducer
  }
})